import { staticText } from '../../../utils/translations/staticText';

export const money101Translation = staticText({
  // TW content: the expanded list mixes card benefits, not reward choices only (CMS-2051).
  product_card_grid_view_all_rewards: {
    _: 'View all {count} rewards',
    zh: '查看 {count} 個卡友權益',
  },
});
